<nb-card>
  <nb-card-header
    ><div class="title p-2">
      Workout Details -
      <small>{{ workoutStart }} - {{ workoutDuration }}</small>
    </div></nb-card-header
  >
  <nb-card-body>
    <ng-container *ngFor="let t of logDetailKeys">
      <app-fitness-workout-log-item
        [exerciseLabel]="t"
        [details]="logDetails[t]"
        [patientId]="patient.id"
      >
      </app-fitness-workout-log-item>
    </ng-container>
  </nb-card-body>
  <nb-card-footer></nb-card-footer>
</nb-card>
